import React, { useState } from "react";

export const TemplateContextProvider = React.createContext();

const TemplateContext = ({ children }) => {


  const [openModal, setOpenModal] = useState(false);
  const [clientLogo, setClientLogo] = useState(null)

  const [headerResizableHeight, setHeaderResizableHeight] = useState();
  const [headerResizableWidth, setHeaderResizableWidth] = useState();
  const [headerUploadedImage, setHeaderUploadedImage] = useState(null);
  const [footerResizableHeight, setFooterResizableHeight] = useState();
  const [footerResizableWidth, setFooterResizableWidth] = useState();
  const [footerUploadedImage, setFooterUploadedImage] = useState(null);
  const [siderLeftResizableHeight, setSiderLeftResizableHeight] = useState();
  const [siderLeftResizableWidth, setSiderLeftResizableWidth] = useState();
  const [siderLeftUploadedImage, setSiderLeftUploadedImage] = useState(null);
  const [siderRightResizableHeight, setSiderRightResizableHeight] = useState();
  const [siderRightResizableWidth, setSiderRightResizableWidth] = useState();
  const [siderRightUploadedImage, setSiderRightUploadedImage] = useState(null);
  const [headerAlignment, setHeaderAlignment] = useState("center");
  const [siderLeftAlignment, setSiderLeftAlignment] = useState("center");
  const [siderRightAlignment, setSiderRightAlignment] = useState("center");
  const [footerAlignment, setFooterAlignment] = useState("center");
  const [showPreview, setShowPreview] = useState(false);
  const [questions, setQuestions] = useState(false)

  const [backgroundColor, setBackgroundColor] = useState();
  const [descriptionBackgroundColor, setDescriptionBackgroundColor] = useState('white');

  const [questionBackgroundColor, setQuestionBackgroundColor] = useState('white');
  const [questionsFontColor, setQuestionsFontColor] = useState('black');

  const [descValue, setDescValue] = useState("");
  const [descWidth, setDescWidth] = useState("")

  const [listChecked, setListChecked] = useState([]);
  const [templateData, setTemplateData] = useState(null)
  const [uploadedCvURL, setUploadedCvURL] = useState(null);


  const [value, setValue] = useState();
  const [checkBoxOpaqueValue, setCheckBoxOpaqueValue] = useState(false);
  const [questionFormOpaqueValue, setQuestionFormOpaqueValue] = useState(false);
  const [headerPercentageWidth, setHeaderPercentageWidth] = useState(null);
  const [footerPercentageWidth, setFooterPercentageWidth] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState();

  return (
    <TemplateContextProvider.Provider
      value={{
        openModal, 
        setOpenModal,
        headerResizableHeight,
        setHeaderResizableHeight,
        headerResizableWidth,
        setHeaderResizableWidth,
        headerUploadedImage,
        setHeaderUploadedImage,
        siderLeftResizableHeight,
        setSiderLeftResizableHeight,
        siderLeftUploadedImage,
        setSiderLeftUploadedImage,
        siderLeftResizableWidth,
        setSiderLeftResizableWidth,
        siderRightResizableHeight,
        setSiderRightResizableHeight,
        siderRightUploadedImage,
        setSiderRightUploadedImage,
        siderRightResizableWidth,
        setSiderRightResizableWidth,
        footerResizableHeight,
        setFooterResizableHeight,
        footerUploadedImage,
        setFooterUploadedImage,
        headerAlignment,
        setHeaderAlignment,
        siderLeftAlignment,
        setSiderLeftAlignment,
        siderRightAlignment,
        setSiderRightAlignment,
        footerAlignment,
        setFooterAlignment,
        footerResizableWidth,
        setFooterResizableWidth,
        showPreview,
        setShowPreview,
        backgroundColor,
        setBackgroundColor,
        descValue,
        setDescValue,
        descWidth, 
        setDescWidth,
        descriptionBackgroundColor, 
        setDescriptionBackgroundColor,
        questionBackgroundColor, 
        setQuestionBackgroundColor,
        questionsFontColor, 
        setQuestionsFontColor,
        listChecked, 
        setListChecked,
        templateData, 
        setTemplateData,
        questions, 
        setQuestions,
        uploadedCvURL, 
        setUploadedCvURL,

        headerPercentageWidth, 
        footerPercentageWidth, 
        setHeaderPercentageWidth,
        setFooterPercentageWidth,

        backgroundImage, 
        setBackgroundImage,
        value, 
        setValue,
        checkBoxOpaqueValue, 
        setCheckBoxOpaqueValue,
        questionFormOpaqueValue, 
        setQuestionFormOpaqueValue,

        clientLogo, 
        setClientLogo,
      }}
    >
      {children}
    </TemplateContextProvider.Provider>
  );
};
export default TemplateContext;
